module.exports = __webpack_public_path__ + "static/img/exclusive_en.5acd2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/product-icon/exclusive_en.png
// module id = a9xc
// module chunks = 71